import Color from 'color'
import { isWeb } from 'APP/Helpers/checkPlatform'
import styled from 'styled-components/native'
import { Animated, View } from 'react-native'
import Icon from 'APP/Converse/Icon'
import { Input } from 'react-native-elements'

export const StyledContainer = styled(View)`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const StyledInputContainer = styled(Animated.View)`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  border-radius: ${({ theme }) => theme.metrics.borderRadius.large};
  margin-left: ${({ theme }) => (isWeb() ? theme.metrics.baseMargin * 0.6 : 0)}px;
  padding-horizontal: ${({ theme }) =>
    isWeb() ? theme.metrics.baseMargin * 0.6 : theme.metrics.baseMargin}px;
  padding-vertical: 2px;
  background-color: ${({ theme }) => Color(theme.colors.text).alpha(0.05).rgb().string()};
`

export const StyledInput = styled(Input).attrs(({ theme }) => ({
  inputStyle: {
    fontFamily: theme.fonts.fontTypes.base,
    fontSize: theme.fonts.fontSize.regular,
    lineHeight: theme.fonts.lineHeight.regular,
    flex: 1,
    borderBottomWidth: 0,
    color: theme.colors.text,
  },
  inputContainerStyle: {
    borderBottomWidth: 0,
  },
  containerStyle: {
    flexGrow: 1,
    width: null,
  },
}))``

export const StyledSearchIcon = styled(Icon)`
  margin-right: ${({ theme }) => theme.metrics.baseMargin * 0.5}px;
`
